import Vue from 'vue';

import {
  BootstrapVue, BootstrapVueIcons, VBPopoverPlugin, VBTooltipPlugin,
} from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/scss/custom.scss';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VBPopoverPlugin);
Vue.use(VBTooltipPlugin);
